import { appConfig } from "src/appConfig";

export const openVirtualScreen = (industry?: string) => {
  const url = industry
    ? `${appConfig.virtualScreenUrl}?industry=${industry}`
    : appConfig.virtualScreenUrl;
  window.open(url, "_blank");
};
